import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import type { SanityDocument } from "@sanity/client";


export default /*@__PURE__*/_defineComponent({
  __name: 'privacy-policy',
  async setup(__props) {

let __temp: any, __restore: any

definePageMeta({
  layout: "default",
  pageTransition: { name: "page", mode: "out-in" },
});

useHead({
  title: "Privacy Policy",
  meta: [{ name: "description", content: "Privacy Policy FamilyAxis" }],
  bodyAttrs: {
    class: "Privacy Policy",
  },
});

defineOgImage("MainOg", {
  title: "Privacy Policy - FamilyAxis",
  description: "How FamilyAxis handles and protects your data.",
  theme: "#bc9fff",
  colorMode: "light",
});

useSeoMeta({
  title: "Privacy Policy | FamilyAxis",
  description:
    "Read FamilyAxis’ Privacy Policy. Learn how we collect, use, and protect your data in compliance with UK and EU GDPR.",
  keywords: "privacy policy, GDPR, data protection, FamilyAxis privacy",
  author: "FamilyAxis",
  ogTitle: "Privacy Policy | FamilyAxis",
  ogDescription: "Our commitment to protecting your data.",
  ogUrl: "https://familyaxis.com/privacy-policy",
  ogType: "website",
  ogSiteName: "FamilyAxis",
  twitterCard: "summary_large_image",
  twitterTitle: "Privacy Policy | FamilyAxis",
  twitterDescription: "How FamilyAxis collects, uses, and protects your data.",
  twitterSite: "@familyaxis",
  robots: "index, follow",
});

const POST_QUERY = groq`*[_type == "page" && slug.current == "privacy-policy"][0]`;
const { data: post } = (
  ([__temp,__restore] = _withAsyncContext(() => useSanityQuery<SanityDocument>(POST_QUERY))),
  __temp = await __temp,
  __restore(),
  __temp
);

return (_ctx: any,_cache: any) => {
  const _component_UPageHero = _resolveComponent("UPageHero")!
  const _component_ContentSanity = _resolveComponent("ContentSanity")!
  const _component_UPage = _resolveComponent("UPage")!
  const _component_UContainer = _resolveComponent("UContainer")!

  return (_openBlock(), _createBlock(_component_UContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_UPage, { class: "prose px-5 md:px-32" }, {
        default: _withCtx(() => [
          _createVNode(_component_UPageHero, {
            title: _unref(post)?.title,
            description: `Last updated: ${_ctx.formatDateString(_unref(post)._updatedAt)}`
          }, null, 8, ["title", "description"]),
          (_unref(post).body)
            ? (_openBlock(), _createBlock(_component_ContentSanity, {
                key: 0,
                blocks: _unref(post).body,
                page: "privacy-policy"
              }, null, 8, ["blocks"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})